import jwt from '../../http/requests/auth/jwt/index.js';

import 'firebase/auth';
import router from '@/router';

import axios from '@/axios';

export default {
  // JWT
  loginJWT(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {
          // If there's user data in response
          if (response.data) {
            resolve(response);
          } else {
            reject({ message: response.data.msg });
          }
        })
        .catch(({ response }) => {
          reject({ message: response.data.msg });
        });
    });
  },
  registerUserJWT(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .registerClinic(payload.userDetails)
        .then(response => {
          // Redirect User
          router.push(router.currentRoute.query.to || '/');
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  checkEmail(_context, email) {
    return new Promise((resolve, reject) => {
      jwt
        .checkEmailAvailability(email)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getInvitationDetail(_context, ref) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/auth/getInvitationDetail', { params: { ref } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllClinic() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/fetchAllClinic')
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/fetchUserList?page=' +
            data.page +
            '&limit=' +
            data.limit +
            '&search=' +
            encodeURIComponent(data.search || '') +
            '&sort=' +
            data.sort +
            '&dir=' +
            data.dir +
            '&userType=' +
            data.userType +
            '&activeClinicId=' +
            data.activeClinicId
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchSupplierClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/fetchSupplierClinicList?page=' +
            data.page +
            '&limit=' +
            data.limit +
            '&search=' +
            encodeURIComponent(data.search || '') +
            '&sort=' +
            data.sort +
            '&dir=' +
            data.dir +
            '&detailSupplierId=' +
            data.detailSupplierId +
            '&state=' +
            data.state
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  generateAdminClinicInvoice(_context, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/v1/admins/generateAdminClinicInvoice?clinic=${param.clinicId}&year=${param.year}&month=${param.monthNumber}`
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchClinicsDetail(_context, id) {
    return new Promise((resolve, reject) => {
      let url = `/api/v1/clinics/userManagement/clinics/${id}/`;

      axios
        .get(url)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateClinicDetail(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/api/v1/clinics/userManagement/clinics/${data.id}/edit/?userType=doctorClinic`,
          data.data
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  resetClinicPassword(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/clinics/userManagement/clinics/' +
            data.id +
            '/resetPassword',
          data.data
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  createClinic(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/clinics/userManagement/clinics/create?userType=doctorClinic',
          data
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  createClinicBasic(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/clinics/userManagement/clinics/create/basic?userType=doctorClinic',
          data
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  deleteClinic(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v1/clinics/userManagement/clinics/' + id + '/delete')
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getClinicDashboardData() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/dashboardData')
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  pairDevice(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/userManagement/clinics/pairDevice', data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err.data);
        });
    });
  },
  unPairDevice(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/userManagement/clinics/unPairDevice', data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err.data);
        });
    });
  },
  fetchPairDevice(_context, clinicId) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/userManagement/clinics/getPairedDevice', {
          params: clinicId,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAssociatedClinics(_context, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/fetchAssociatedClinics?page=' +
            param.options.page +
            '&limit=' +
            param.options.limit +
            '&search=' +
            encodeURIComponent(param.options.search || '') +
            '&sort=' +
            param.options.sort +
            '&dir=' +
            param.options.dir +
            '&uid=' +
            param.uid +
            '&userType=doctorClinic'
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeAssociatedClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/clinics/userManagement/clinics/removeAssociatedClinics',
          data
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchToPairClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/userManagement/clinics/fetchClinicToPair', {
          params: data,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAllTreatmentHistory(_context, params) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/getAllTreatmentHistories', params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchClinicAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/fetchClinicAdmin', { params: data })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createClinicAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/createClinicAdmin', data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicAdminDetail(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/fetchClinicAdminDetail/' + id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateClinicAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          '/api/v1/clinics/updateClinicAdmin/' + data.clinicId,
          data.clinicData
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteSubClinic(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v1/clinics/deleteClinicAdmin/' + id)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getStripePublishableKey() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/bankDetails/getPublishableKey')
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  createSetupIntent() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/bankDetails/createSetupIntent')
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getMandateObject(_context, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/v1/clinics/bankDetails/getMandateObject?intentId=${
            param.intentId
          }&accountHolderName=${
            param.accountHolderName
          }&accountHolderEmail=${encodeURIComponent(param.accountHolderEmail)}`
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  submitStepDefaultPayment({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/api/v1/clinics/default-payment-method/${payload.userId}/submit`,
          payload.body
        )
        .then(res => {
          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}FirstName`,
            res.data.data.firstName
          );

          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`,
            JSON.stringify(res.data.data)
          );

          commit('UPDATE_USER_INFO', res.data.data, { root: true });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  saveClinicBankDetails({commit}, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/bankDetails/create', data)
        .then(res => {
          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}FirstName`,
            res.data.data.user.firstName
          );

          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`,
            JSON.stringify(res.data.data.user)
          );

          commit('UPDATE_USER_INFO', res.data.data.user, { root: true });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateClinicBankDetails({commit}, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/bankDetails/edit', data)
        .then(res => {
          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}FirstName`,
            res.data.data.firstName
          );

          localStorage.setItem(
            `${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`,
            JSON.stringify(res.data.data)
          );

          commit('UPDATE_USER_INFO', res.data.data, { root: true });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getExistingDoctorRate() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/getExistingDoctorRate')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  saveDoctorRate(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/clinics/saveDoctorRate', data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  getClinicDoctorRate() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/getClinicDoctorRate')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  uploadClinicImages(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/clinics/uploadClinicImages?key=' + payload.key,
          payload.data,
          payload.config
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  removeClinicImages(_context, imageUrl) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/removeClinicImages?imageUrl=' + imageUrl)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  resendVerificationEmail(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/onboardBusiness/resendEmail', payload)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  checkIfFranchiseClinic({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/checkIfFranchiseClinic')
        .then(res => {
          commit('IS_FRANCHISE_CLINIC', res.data.data);
          resolve(res);
        })
        .catch(err => reject(err));
    });
  },
  fetchTreatmentAreas(_context, dataTableParams) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/clinics/applicableAreas', { params: dataTableParams })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  changeTreatmentAreaStatus(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/v1/clinics/applicableAreas/changeStatus', payload)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  fetchDefaultConsentList() {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/questionnaire-management?page=' +
            1 +
            '&limit=' +
            25 +
            '&search=&sort=createdAt&dir=asc'
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchCustomConsentList(_context, clinicId) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/custom-consent/' + clinicId)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  changeCustomConsentOrders(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/custom-consent/' + data._id, data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
};
